import { render } from "./BomSpecsContainer.vue?vue&type=template&id=038d3ba2&scoped=true"
import script from "./BomSpecsContainer.vue?vue&type=script&lang=js"
export * from "./BomSpecsContainer.vue?vue&type=script&lang=js"

import "./BomSpecsContainer.vue?vue&type=style&index=0&id=038d3ba2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038d3ba2"]])

export default __exports__